/****************************************************
 * Module Name:  addPackage.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddPackage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            responseData: [],
            newDepartmentGroup: "",
            numberofpackets: 0,
            showError: false,
            showIssueUsersLoadSpinner: true,
            packetsValidationError: "",
        };
    }

    handleSave = () => {
        let data = {
            kapanid: this.props.sourceData.id || this.props.sourceData.kapanid,
            createdby: Constants.loggedInUser.id,
            totalpackets: Number(this.state.numberofpackets),
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data)) this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    buttonDisable = () => {
        return this.state.packetsValidationError.length !== 0 || this.state.numberofpackets === 0
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Packaging validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />
                <Modal show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            Package
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Form.Label>Kapan Id</Form.Label>
                                        </td>
                                        <td>
                                            <Form.Label>{this.props.sourceData.id || this.props.sourceData.kapanid}</Form.Label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Carats</Form.Label>
                                        </td>
                                        <td>
                                            <Form.Label>{this.props.sourceData.carats}</Form.Label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Price Per Carat</Form.Label>
                                        </td>
                                        <td>
                                            <Form.Label>{this.props.sourceData.price}</Form.Label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Kapan Price</Form.Label>
                                        </td>
                                        <td>
                                            <Form.Label>{(this.props.sourceData.carats * this.props.sourceData.price).toFixed(2)}</Form.Label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    {this.props.kapanToPacket && (
                                        <>
                                            <tr>
                                                <td>
                                                    <Form.Label>Pcs</Form.Label>
                                                </td>
                                                <td>
                                                    <Form.Label>{this.props.sourceData.pcs}</Form.Label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                            </tr>
                                        </>
                                    )}
                                    <tr>
                                        <td>
                                            <Form.Label>Number of Packets</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                size="small"
                                                fullWidth
                                                inputMode="numeric"
                                                type={"number"}
                                                label="Number of packets"
                                                placeholder="Number of packets"
                                                value={this.state.numberofpackets}
                                                onChange={(e) =>
                                                    this.setState({
                                                        numberofpackets: e.target.value,
                                                        packetsValidationError:
                                                            e.target.value <= 0
                                                                ? "Number of packets should be a positive number"
                                                                : this.props.kapanToPacket
                                                                    ? e.target.value > this.props.sourceData.pcs
                                                                        ? `Number of packets cannot be greater than ${this.props.sourceData.pcs}`
                                                                        : ""
                                                                    : e.target.value > 26
                                                                        ? "Number of packets cannot be greater than 26"
                                                                        : ""
                                                    })
                                                }
                                                helperText={this.state.packetsValidationError}
                                                error={this.state.packetsValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Create Packets
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
